import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { StatusCode } from "api/protocols";
import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";
import Page from "components/page/Page";
import { GetFoodOrderingCategories } from "api/rpc/2024-04/facilityAdmin/facility/foodOrdering";
import DataTable from "components/dataTable/DataTable";

interface IFoodOrderingCategoryState {
  categories: any[];
}

export default function FoodOrderingCategories() {
  const history = useHistory();
  const { t } = useTranslation();

  const [foodOrderingState, setFoodOrderingState] = useState<IFoodOrderingCategoryState>({
    categories: undefined,
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadFoodOrderingCategories();
    return () => source.cancel();
  }, []);

  async function loadFoodOrderingCategories() {
    const categoryRes = await GetFoodOrderingCategories(null, true);

    if (categoryRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading settings")));
      return;
    }

    setFoodOrderingState((prevState) => ({ ...prevState, categories: categoryRes.data }));
  }

  return (
    <Page
      title={t("Food Ordering Categories")}
      subtitle={t("Manage Food Ordering Categories")}
      primaryAction={{
        content: t("New Category"),
        action: () => history.push("/admin/settings/food-ordering/categories/new"),
      }}
    >
      <DataTable
        columns={[{ label: t("Title") }]}
        loading={foodOrderingState.categories === undefined}
      >
        {foodOrderingState.categories?.length > 0 ? (
          foodOrderingState.categories?.map((category: any, index: number) => {
            return (
              <tr
                key={index}
                onClick={() => history.push("/admin/settings/food-ordering/categories/" + String(category.id))}
                className="clickable"
              >
                <td>
                  <p>{category.title}</p>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td>{t("There are currently no categories")}</td>
          </tr>
        )}
      </DataTable>
    </Page>
  );
}
